import { useNavigate } from "@solidjs/router";
import { Show, createEffect, createMemo } from "solid-js";

export const CertificateButtons = props => {
	const navigate = useNavigate();

	const certificate = createMemo( () =>
		typeof props.certificate === "function"
			? props.certificate()
			: props.certificate
	);

	const computed = createMemo( () => {
		const cert = certificate();

		const isPaid = cert?.status === "paid";
		const isStaged = cert?.meta?.isStagedCertificate;

		let link = null;
		let caption;
		let state = {
			projectId: props.projectId,
			certificateId: null,
			amendment: 0,
			stage: 0,
		};

		if ( !cert ) {
			caption = "Create";

		} else if ( !isPaid ) {
			link = cert.sk.replace( "CERTIFICATE#", "" );
			caption = "Edit";
			state.amendment = ( cert.meta?.amendments?.length ?? 0 ) + 1;
			state.stage = ( cert.meta?.stages?.length ?? 0 ) + 1;

		} else {
			state.certificateId = cert.sk;

			if ( isStaged ) {
				state.stage = ( cert.meta?.stages?.length ?? 0 ) + 1;
				caption = "Add Stage";
			} else {
				state.amendment = ( cert.meta?.amendments?.length ?? 0 ) + 1;
				caption = "Add Amendment";
			}
		}

		return { link, caption, state, isPaid, isStaged };
	} );

	{/* 

	let link = null, caption, state = { projectId: props.projectId, certificateId: null, amendment: 0, stage: 0 };

	if ( !certificate() ) {
		caption = 'Create';

	} else if ( !isPaid ) {
		link = certificate().sk.replace( 'CERTIFICATE#','' );

		caption = 'Edit';

	} else {
		state.certificateId = certificate().sk;
		if ( isStaged ) {
			state.stage = ( certificate()?.meta?.stages?.length ?? 0 ) + 1
			caption = 'Add Stage';
		} else {
			state.amendment = ( certificate()?.meta?.amendments?.length ?? 0 ) + 1;
			caption = 'Add Amendment';
		}
	}
*/}

	return (
		<>
			<button type="button" class="rias px-2 py-1 text-xs" onClick={() => navigate( `/dashboard/certificate/${computed().link ?? 'new'}`, { state: computed().state } )}>{computed().caption}</button>

			<Show when={computed().isPaid && computed().isStaged}>
				&nbsp;<button type="button" class="rias px-2 py-1 text-xs" onClick={() => navigate( `/dashboard/certificate/new`, { state: { ...computed().state, amendment: ( certificate()?.meta?.amendments?.length ?? 0 ) + 1 } } )}>Add Amendment</button>
			</Show>
		</>
	)
}